module.exports = __webpack_public_path__ + "img/arrow_forward_ios_24px.bb5169b7.svg";